import React, {
  CSSProperties,
  ChangeEvent,
  FocusEvent,
  KeyboardEvent,
  MouseEvent,
  useEffect,
  useRef,
  useState
} from 'react';

import styles from '../styles/InlineTextEdit.scss';

export interface InlineTextEditProps {
  value: string;
  style?: CSSProperties;
  placeholder?: string;
  className?: string;
  onChange: (value: string) => void;
  onBeforeClick?: (event: MouseEvent<HTMLSpanElement>) => void;
}

export function InlineTextEdit(props: InlineTextEditProps) {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(props.value);

  const inputRef = useRef(null);

  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    } else {
      if (value && value !== props.value) {
        props.onChange(value);
      }
    }
  }, [editing]);

  function handleClick(event: MouseEvent<HTMLSpanElement>) {
    if (props.onBeforeClick) {
      props.onBeforeClick(event);
    }
    setEditing(true);
    setValue(props.value || '');
  }

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    setValue(event.target.value);
  }

  function handleBlur() {
    setEditing(false);
  }

  function handleKeyup(event: KeyboardEvent<HTMLInputElement>) {
    if (event.key === 'Enter') {
      setEditing(false);
    }
  }

  return (
    <span className={styles.inlineTextSpanContainer}>
      {!editing ? (
        <span
          className={`${props.className || ''} ${styles.inlineTextActive} ${
            props.placeholder && !props.value ? styles.placeholderColor : ''
          }`}
          style={props.style}
          onClick={handleClick}
        >
          {props.placeholder && !props.value ? props.placeholder : props.value}
        </span>
      ) : (
        <input
          ref={inputRef}
          className={`${props.className || ''}  ${
            styles.inlineTextInputActive
          }`}
          style={props.style}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyUp={handleKeyup}
        />
      )}
    </span>
  );
}
